import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';


@Component({
  selector: 'app-monthly-billing',
  templateUrl: './monthly-billing.component.html',
  styleUrl: './monthly-billing.component.css'
})
export class MonthlyBillingComponent {
 billingForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.billingForm = this.fb.group({
      module: ['Monthly Billing'],
      features: this.fb.array(['Monthly billing calculation', 'Invoice generation']),
      forms: this.fb.array(['Billing form', 'Invoice form']),
      systemAction: this.fb.array(['System calculates monthly billing', 'Generates invoice']),
      benefits: this.fb.array(['Accurate billing system', 'Scalability']),
      kpi: ['Monthly billing cycle adherence']
    });
  }

  get features() { return this.billingForm.get('features') as FormArray; }
  get forms() { return this.billingForm.get('forms') as FormArray; }
  get systemAction() { return this.billingForm.get('systemAction') as FormArray; }
  get benefits() { return this.billingForm.get('benefits') as FormArray; }

  onSubmit() {
    console.log(this.billingForm.value);
  }
}